import React, { useRef } from 'react';
import {
  oneOfType, string, bool, number, func,
} from 'prop-types';
import { InputWrapV2 } from './InputV2Styles';

const InputV2 = ({
  id,
  name,
  className,
  type,
  placeholder,
  disabled,
  hasError,
  errorMsg,
  hasMessage,
  lengthMessage,
  value,
  onChange,
  readOnly,
  required,
  selectAllOnFocus,
  skipLengthCheck,
  ariaDescribedBy,
  ...props
}) => {
  const inputRef = useRef(null);

  return (
    <InputWrapV2 hasError={hasError} hasMessage={hasMessage}>
      <input
        id={id}
        type={type}
        name={name || id}
        placeholder={placeholder}
        aria-invalid={hasError}
        aria-required={required}
        aria-describedby={ariaDescribedBy?.length ? ariaDescribedBy : `${id}_error`}
        disabled={disabled}
        readOnly={readOnly}
        className={`${className} ${hasError ? 'error' : ''}`}
        value={value}
        onChange={onChange}
        ref={inputRef}
        onFocus={selectAllOnFocus
          ? () => {
            inputRef.current.select();
          }
          : null
        }
        {...props}
      />
      <div id={`${id}_error`} aria-live="assertive">
        {hasError && <div className="errorText">{errorMsg}</div>}
        {!skipLengthCheck && hasMessage && <div className="errorText" id={`${id}_message`}>{lengthMessage}</div>}
      </div>
    </InputWrapV2>
  );
};

InputV2.propTypes = {
  id: string.isRequired,
  name: string,
  hasError: bool,
  hasMessage: bool,
  skipLengthCheck: bool,
  className: string,
  type: string,
  placeholder: string,
  disabled: bool,
  readOnly: bool,
  required: bool,
  ariaDescribedBy: string,
  lengthMessage: string, // maybe standardize to msg
  errorMsg: string,
  value: oneOfType([
    string,
    number,
  ]).isRequired,
  onChange: func.isRequired,
  selectAllOnFocus: bool,
};

InputV2.defaultProps = {
  hasError: false,
  hasMessage: false,
  skipLengthCheck: false,
  disabled: false,
  readOnly: false,
  required: false,
  ariaDescribedBy: null,
  errorMsg: '',
  lengthMessage: '',
  name: 'mlinput',
  className: '',
  placeholder: '',
  type: 'text',
  selectAllOnFocus: false,
};

export default InputV2;
